module.exports = __webpack_public_path__ + "media/images/lb/901-355f933d3b75e024822235f61aeb7a15.svg";